export default __webpack_public_path__ + "dbc89e675ca4e89c3fc046439f0d7cb7.png";